import * as React from 'react';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';

const codeMirrorOptions = {
    lineNumbers: false,
    readOnly: true,
    mode: { name: "alanKeywords", json: true, globalVars: true },
};

function TaskCodeViewer({ code }) {
    return <div className={`task-code-viewer`}>
        <ReactCodeMirror
            value={code}
            options={codeMirrorOptions} />
    </div>
}

export default TaskCodeViewer;